import {
  CHAT_TYPE,
  GROUP_TYPE,
  IGroupInfo,
  IInfoType,
  IMessageData,
  IStarredMessageTypeData,
} from "@home-health-notify/domain";
import { PatientHeaderDescription } from "../message/messageHeader/patientGroupHeader/PatientHeaderDescription";
import React from "react";
import { CommonChatHeaderDescription } from "../message/messageHeader/CommonChatHeaderDescription";
import { getAvatarSize, GROUP_AVATAR_SIZE } from "../utils/AvatarUtils";
import { AlertListItemHeaderWrapper } from "./Alert.style";
import { AlertTypeDataProps } from "./AlertMessagesList";

const AlertListItemHeader = ({
  data,
}: {
  data: AlertTypeDataProps | IStarredMessageTypeData;
}) => {
  let messageData = data.message?.getMessage() as IMessageData;
  const chatType = messageData?.chatType;
  const groupType = data.info?.groupType as GROUP_TYPE;
  const avatarSize = getAvatarSize(groupType, GROUP_AVATAR_SIZE.SMALL);
  const info = data.info as IInfoType;

  return (
    <AlertListItemHeaderWrapper>
      {groupType === GROUP_TYPE.NON_PATIENT && (
        <CommonChatHeaderDescription
          chatInfo={info}
          avatarSize={avatarSize}
          maxWidth={260}
        />
      )}
      {groupType === GROUP_TYPE.PATIENT && (
        <PatientHeaderDescription
          name={info.name}
          patientStatus={(info as IGroupInfo).patientStatus}
          servicesToPatient={(info as IGroupInfo).servicesToPatient}
          meta={(info as IGroupInfo).meta}
        />
      )}
      {(chatType === CHAT_TYPE.PRIVATE || chatType === CHAT_TYPE.BROADCAST) && (
        <CommonChatHeaderDescription chatInfo={info} avatarSize={avatarSize} />
      )}
    </AlertListItemHeaderWrapper>
  );
};

export default AlertListItemHeader;
